import { all, takeLatest } from 'lib/redux';
import {
  FETCH_ORDER_CLOSURE_REASONS, CANCEL_ORDER,
} from 'constants/ActionTypes';
import { cancelOrderSaga, fetchOrderClosureReasonsSaga } from './CancelOrder.saga';

/**
 * Defines the watchers related to Cancel Order Dialog.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(FETCH_ORDER_CLOSURE_REASONS, fetchOrderClosureReasonsSaga),
    takeLatest(CANCEL_ORDER, cancelOrderSaga),
  ]);
}
